/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unused-expressions */
import { FieldError, } from 'react-hook-form';
import React, { InputHTMLAttributes, useEffect, useRef, } from 'react';
import './Input.css';
import { ErrorInput, } from '../errors/ErrorInput';
import { ServerErrors, } from '../../types';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  maxLength: number;
  name: string;
  id: string;
  placeholder: string;
  focus?: boolean;
  register: any;
  errors: FieldError | undefined;
  serverErrors?: ServerErrors | null;
  validate?: string;
  value?: string;
  disabled?: boolean;
}

export const InputText = ({
  name,
  id,
  maxLength,
  placeholder,
  focus,
  required,
  register,
  errors,
  serverErrors,
  validate,
  value,
  disabled,
  ...rest
}: InputProps) => {
  const hasValue = value != null && value !== '';

  // Ref
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(
    () => {
      setTimeout(
        () => {
          focus && inputRef?.current?.focus();
        }, 200
      );
    }, [ focus, ]
  );
  return (
    <div className='input'>
      <input
        ref={inputRef}
        className={`input__data ${required && 'required'}`}
        type='text'
        name={name}
        id={id}
        autoComplete='off'
        tabIndex={0}
        maxLength={maxLength}
        placeholder={placeholder}
        required={required}
        value={value}
        disabled={disabled}
        style={{ backgroundColor: disabled ? 'rgb(140, 163, 186)' : '', }}
        {...register(name)}
        {...rest}
      />
      <label className={`input__label ${hasValue || disabled ? 'has-value' : ''}`} style={{ backgroundColor: disabled ? 'transparent' : '', color: disabled ? 'transparent' :'', }} htmlFor={id}>
        {`${id} ${required ? '*' : ''}`}
      </label>
      {!errors && !serverErrors && <div style={{ height: '20px', }}/>}
      <ErrorInput
        errors={errors}
        serverErrors={serverErrors}
        errorName={name}
        validate={validate}
      />
    </div>
  );
};
